var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"spinnerId","centered":"","hide-header":true,"hide-footer":true,"no-close-on-backdrop":true,"hide-header-close":true}},[_c('b-spinner',{attrs:{"label":_vm.label}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }